import {
  extendsModule, baseFormGroup, registerMfModule, moduleKeys,
} from 'src/store/base';
import * as types from 'src/store/types';

import proceduralCreativeTitleList from './procedural-creative-title-list';
import proceduralCreativeName from './procedural-creative-name';
import proceduralCreativeCta from './procedural-creative-cta';
import proceduralCreativeCreate from './procedural-creative-create';
import proceduralCreativeAppName from './procedural-creative-app-name';
import proceduralCreativeDefferedDeeplink from './procedural-creative-deffered-deeplink';
import proceduralCreativeAvatar from './procedural-creative-avatar';
import proceduralCreativeTrackingUrl from './procedural-creative-tracking-url';
import proceduralCreativeOptimize from './procedural-creative-optimize';
import proceduralCreativeLibAuth from './procedural-creative-lib-auth';
import proceduralCreativeIdentity from './procedural-creative-identity';

export default extendsModule(baseFormGroup, {
  state: {
    _moduleKey: 'form-group-main',
    _formItems: moduleKeys([proceduralCreativeTitleList, proceduralCreativeName, proceduralCreativeCta,
      proceduralCreativeCreate, proceduralCreativeAppName, proceduralCreativeDefferedDeeplink,
      proceduralCreativeAvatar, proceduralCreativeTrackingUrl, proceduralCreativeOptimize, proceduralCreativeLibAuth,
      proceduralCreativeIdentity]),
    showCta: true,
  },
  mutations: {
    [types.UPDATE_PCD_SHOW_CTA](state, show) {
      state.showCta = !!show;
    },
  },
  // 把数组中的对象合并成一个大对象
  modules: registerMfModule([proceduralCreativeTitleList, proceduralCreativeName, proceduralCreativeCta, proceduralCreativeCreate,
    proceduralCreativeAppName, proceduralCreativeDefferedDeeplink,
    proceduralCreativeAvatar, proceduralCreativeTrackingUrl, proceduralCreativeOptimize, proceduralCreativeLibAuth,
    proceduralCreativeIdentity]),
});
